import Vue from 'vue';
import VueRouter from 'vue-router';
import addTransferRoutes from './addtransferstorun';
import creditTransferRoutes from './credittransfer';
import creditRunRoutes from './credittransferpaymentrun';
import partyRoutes from './party';
import securityRoutes from'./security';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [addTransferRoutes, creditTransferRoutes, creditRunRoutes, partyRoutes, securityRoutes]
});
